import { useTheme } from 'styled-components'

import { IconBase, IconProps } from './Base'

export const IconClone = (props: IconProps) => {
  const theme = useTheme()
  return (
    <IconBase
      width={props.width || 22}
      height={props.height || 22}
      viewBox="0 0 36 36"
      fill={theme.colors.text.primary}
    >
      <path
        d="M6,6H22v4h2V6a2,2,0,0,0-2-2H6A2,2,0,0,0,4,6V22a2,2,0,0,0,2,2h4V22H6Z"
        className="clr-i-outline clr-i-outline-path-1"
      />
      <path
        d="M30,12H14a2,2,0,0,0-2,2V30a2,2,0,0,0,2,2H30a2,2,0,0,0,2-2V14A2,2,0,0,0,30,12Zm0,18H14V14H30Z"
        className="clr-i-outline clr-i-outline-path-2"
      />
      <polygon
        points="21 28 23 28 23 23 28 23 28 21 23 21 23 16 21 16 21 21 16 21 16 23 21 23 21 28"
        className="clr-i-outline clr-i-outline-path-3"
      />
      <rect x="0" y="0" width="36" height="36" fillOpacity="0" />
    </IconBase>
  )
}
